/**
 * RS-6 — the stamp, drawn on screen exactly as it prints.
 *
 * One box, used twice: on the review sheet once a submittal is stamped, and in
 * Admin → Documents → Paper rules as a live preview while the wording is
 * typed. Both must look like the paper, so there is one component.
 */
const TONE = {
  approved: 'var(--km-ok)',
  approved_as_noted: 'var(--km-wait)',
  resubmit: 'var(--km-brand)',
  rejected: 'var(--km-late)',
};

export const STAMP_PRINT = {
  approved: 'APPROVED',
  approved_as_noted: 'APPROVED AS NOTED',
  resubmit: 'REVISE AND RESUBMIT',
  rejected: 'REJECTED',
};

export const StampBox = ({ stamp = 'approved', firm = '', initials = '', date = '',
  wording = '', third = '', label = '', testId = 'stamp-box' }) => {
  const tone = TONE[stamp] || TONE.approved;
  return (
    <div
      data-testid={testId}
      style={{
        border: '1.5px solid',
        borderColor: tone,
        background: 'var(--km-paper)',
        padding: 'var(--km-s3) var(--km-s3)',
        width: '100%',
        maxWidth: 320,
        fontFamily: 'var(--km-label)',
      }}
    >
      <div style={{
        color: tone,
        fontWeight: 700,
        fontSize: 'var(--km-t-lead)',
        letterSpacing: 'var(--km-track-tech)',
      }}>
        {label || STAMP_PRINT[stamp] || STAMP_PRINT.approved}
      </div>
      <div style={{ color: 'var(--km-ink)', fontSize: 'var(--km-t-code)', marginTop: 'var(--km-s1)' }}>
        {[firm, initials, date].filter(Boolean).join(' · ')}
      </div>
      {third ? (
        <div style={{ color: 'var(--km-ink)', fontSize: 'var(--km-t-code)',
          marginTop: 'var(--km-s1)' }} data-testid={`${testId}-third`}>
          {third}
        </div>
      ) : null}
      <div style={{
        color: 'var(--km-ink-2)',
        fontSize: 'var(--km-t-micro)',
        marginTop: 'var(--km-s1)',
        lineHeight: 1.45,
      }}>
        {wording}
      </div>
    </div>
  );
};

export default StampBox;
